import { pluginsApi } from "@/Api/Plugins";
import { pushToStoreList } from "@/Store/StoreExternalAccess";
import { PopupVariant, } from "@/UI/Layout/Popups/InterfacesAndEnums";
// Import startWaitSpinner as startWaitSpinnerSrc
import { startWaitSpinner as startWaitSpinnerSrc } from "@/UI/MessageAlerts/WaitSpinner";
import { stopWaitSpinner as stopWaitSpinnerSrc } from "@/UI/MessageAlerts/WaitSpinner";
import { describeParameters } from "@/UI/Panels/Log/LogUtils";
export const messagesApi = {
    /**
     * Displays a popup message.
     *
     * @param  {string}       title                        The title of the
     *                                                     popup.
     * @param  {string}       message                      The message to
     *                                                     display.
     * @param  {PopupVariant} [variant=PopupVariant.Info]  The type of message.
     * @param  {Function}     [callBack]                   A function to call
     *                                                     when the popup is
     *                                                     closed.
     * @param  {boolean}      [neverClose=false]           If true, the modal
     *                                                     can never be closed.
     */
    popupMessage: function (title, message = "", variant = PopupVariant.Info, callBack = undefined, neverClose = false) {
        // If popup already open, do not open another one.
        pluginsApi.runPlugin("simplemsg", {
            title,
            message,
            variant,
            neverClose,
            callBack,
            open: true, // open
        });
    },
    /**
     * Closes the popup message.
     */
    closePopupMessage: function () {
        pluginsApi.runPlugin("simplemsg", {
            title: "",
            message: "",
            open: false, // close
        });
    },
    /**
     * Displays an error popup.
     *
     * @param  {string}   message     The error message.
     * @param  {Function} [callBack]  A function to call when the popup is
     *                                closed.
     */
    popupError: function (message, callBack) {
        this.popupMessage("Error", message, PopupVariant.Danger, callBack);
    },
    /**
     * Starts a wait spinner. Returns an id that can be used to stop the spinner.
     *
     * @param {number} [timeOut=30000]  The timeout in milliseconds.
     * @returns {string}  The id of the spinner.
     */
    startWaitSpinner: function (timeOut = 30000) {
        return startWaitSpinnerSrc(timeOut);
    },
    /**
     * Stops a wait spinner.
     *
     * @param {string} id  The id of the spinner.
     */
    stopWaitSpinner: function (id) {
        stopWaitSpinnerSrc(id);
    },
    /**
     * Logs a message. Appears in the log at the bottom of the screen.
     *
     * @param {string} message       The message to log.
     * @param {any}    [parameters]  The parameters associated with this log, if
     *                               any.
     * @param {string} [jobId]       The job ID associated with this log, if
     *                               any.
     */
    log: function (message, parameters, jobId) {
        // Get current local time as string. Like "2020-01-01 12:00"
        const now = new Date();
        const timestamp = now.toLocaleString("en-US", {
            hour12: true,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        });
        const timestampInt = Math.round(now.getTime() / 1000);
        const paramDesc = describeParameters(parameters);
        // Add the message to the log
        pushToStoreList("log", {
            timestamp,
            timestampSecs: timestampInt,
            message,
            parameters: paramDesc,
            jobId: jobId,
        });
    },
};
